module.exports = __webpack_public_path__ + "static/media/41.ca571fcf.jpeg";